export default "__VITE_ASSET__BlUjX54D__"